let _faceapi = null;
let modelsLoaded = false;
let loadPromise  = null;

export function getFaceApi() {
  return _faceapi;
}

export async function loadModels() {
  if (modelsLoaded) return;
  if (loadPromise)  return loadPromise;
  loadPromise = (async () => {
    _faceapi = await import('face-api.js');
    await Promise.all([
      _faceapi.nets.tinyFaceDetector.loadFromUri('/models'),
      _faceapi.nets.faceLandmark68Net.loadFromUri('/models'),
      _faceapi.nets.faceRecognitionNet.loadFromUri('/models'),
    ]);
    modelsLoaded = true;
    loadPromise = null;
  })();
  loadPromise.catch(() => { loadPromise = null; });
  return loadPromise;
}

export async function detectFace(videoEl) {
  return _faceapi
    .detectSingleFace(videoEl, new _faceapi.TinyFaceDetectorOptions({ inputSize: 224, scoreThreshold: 0.5 }))
    .withFaceLandmarks()
    .withFaceDescriptor();
}
